// A work item's own address: https://<site>/<KEY>.
//
// Jira's /browse/KEY, shortened — the link "Copy link" puts on the
// clipboard, and the one a person pastes into a mail or a chat. Opening it
// draws the work item's screen as a tab of its own (web/src/App.jsx routes
// both /KEY and /browse/KEY here, so links Stride already printed as
// /browse/KEY — reports, the grids' "open in a new tab" — land too).
//
// Pure: no React, no DOM beyond what a caller passes in.

// A Jira-shaped key: a project key (a letter, then letters, digits or _)
// and a number. Case-insensitive on the way in — keys are stored upper-case.
const ISSUE_KEY_RE = /^[A-Za-z][A-Za-z0-9_]*-\d+$/;

export function isIssueKey(text) {
  return ISSUE_KEY_RE.test(String(text || '').trim());
}

export function normaliseIssueKey(text) {
  const t = String(text || '').trim();
  return ISSUE_KEY_RE.test(t) ? t.toUpperCase() : null;
}

// The in-app path a work item opens at.
export function workItemPath(key) {
  return `/${encodeURIComponent(String(key))}`;
}

// The full, shareable address — `origin` is the site the reader is on.
export function workItemUrl(key, origin) {
  return `${String(origin || '').replace(/\/+$/, '')}${workItemPath(key)}`;
}

// '/STOCK2026-675' or '/browse/STOCK2026-675' → 'STOCK2026-675'; any other
// path → null. A page's own route (/alerts, /home…) never parses as a key.
export function issueKeyFromPath(pathname) {
  const p = String(pathname || '').split(/[?#]/)[0];
  const m = p.match(/^\/(?:browse\/)?([^/]+)\/?$/);
  if (!m) return null;
  let seg;
  try { seg = decodeURIComponent(m[1]); } catch { return null; }
  return normaliseIssueKey(seg);
}
